/** @format */

export const studyYearTemplateModelModule = 'sis-components.model.studyYearTemplate';

(function () {
    studyYearTemplateModel.$inject = ['DS'];
    angular
        .module(studyYearTemplateModelModule, ['js-data'])
        .factory('studyYearTemplateJSDataModel', studyYearTemplateModel)
        .run(['studyYearTemplateJSDataModel', function (studyYearTemplateJSDataModel) {}]);

    function studyYearTemplateModel(DS) {
        return DS.defineResource({
            idAttribute: 'id',
            name: 'studyYearTemplate',
            endpoint: '/kori/api/study-year-templates',
            methods: {
                generateTemplateLocatorString: function (termIndex, periodIndex) {
                    var templateStartYear = moment(this.valid.startDate).format('YYYY');
                    return this.org + '/' + templateStartYear + '/' + termIndex + '/' + periodIndex;
                },
            },
        });
    }
})();
